// extracted by mini-css-extract-plugin
export var themeScpo = "theme-scpo-module--themeScpo--6f563";